<div class="container">
  <biz-terms-of-service
    [tosApiProfileId]="tosApiProfileId"
    [apiRequestBody]="{}"
    [checkboxText]="checkboxText"
    [loadingButtonLabel]="loadingButtonLabel"
    [buttonLabel]="buttonLabel"
    [submitting]="sending"
    (clickAgree)="register($event)"
  ></biz-terms-of-service>
</div>
